import ServiceGraphQL from 'src/service/gql-service';
import { createVendor } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateVendor = (data) => {
  const params = {
    query: createVendor.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
